import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import toast, { Toaster } from "react-hot-toast";
import * as services from "./../services/saleng";
import logo from "../images/scrapyard.svg";

// Update schema to use username instead of email
const schema = yup.object().shape({
  username: yup.string().required("Please enter username"),
  password: yup
    .string()
    .min(8, "Password must be at least 8 characters")
    .max(20, "Password must not exceed 20 characters")
    .notOneOf(
      [yup.ref("username"), null],
      "Password must not be the same as your username",
    )
    .required("Please enter password"),
});

export default function Login() {
  const navigate = useNavigate();
  const clearAuthSession = () => {
    localStorage.removeItem("accessTokenGreen");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("shopName");
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      username: "",
      password: "",
    },
  });

  const onSubmitNew = async (data) => {
    console.log(data);

    const payload = {
      username: data.username,
      password: data.password,
    };

    try {
      // Attempt login
      const greenResponse = await services.loginGreen(payload);
      const greenData = greenResponse.data;

      if (!greenData.success) {
        // Handle login failure
        toast.error(greenData.error || "Something went wrong");
        return;
      }

      console.log("Login successfully (Green):", greenData);

      // Store Green API token separately
      const { accessToken: greenAccessToken } = greenData.data;
      console.log("Green AccessToken:", greenAccessToken);
      localStorage.setItem("accessTokenGreen", greenAccessToken);
      localStorage.setItem("accessToken", greenAccessToken);

      // Fetch shop data
      const shopInfoResponse = await services.getShop();
      const shopInfoData = shopInfoResponse.data.data;

      if (shopInfoData) {
        console.log("Shop data retrieved successfully.");
        localStorage.setItem("shopName", shopInfoData?.name);
        navigate("/products");
        return;
      }

      // If shop data is not found, create a new shop
      const createShopResponse = await services.createShop(payload);
      console.log("Shop created successfully:", createShopResponse);
      navigate("/products");
    } catch (error) {
      clearAuthSession();
      // Handle errors (both login and shop-related)
      toast.error(error?.response?.data?.error || "Something went wrong");
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-custom-gray">
      <Toaster />
      <form
        onSubmit={handleSubmit(onSubmitNew)}
        className="w-full max-w-md p-8 space-y-4 bg-white shadow-md rounded-2xl"
      >
        <div className="flex items-center justify-center mb-6">
          <img
            src={logo}
            alt="logo"
            style={{ width: "350px", height: "auto" }}
          />
        </div>
        <h2 className="text-2xl font-bold mb-7 text-center mt-3 text-blue-900">
          Admin
        </h2>
        <div>
          <h2 className="text-2xl font-bold mb-7 text-center mt-3 text-blue-900">
            เข้าสู่ระบบ
          </h2>

          <div className="mt-5">
            <label htmlFor="username" className="text-sm font-semibold mb-1">
              ชื่อผู้ใช้
            </label>
            <input
              className="w-full px-3 py-2 border rounded"
              type="text"
              placeholder="ชื่อผู้ใช้"
              {...register("username")}
            />
            {errors?.username && (
              <p className="text-red-500 text-xs mt-1">
                {errors.username?.message}
              </p>
            )}
          </div>

          <div className="mt-5">
            <label htmlFor="password" className="text-sm font-semibold mb-1">
              รหัสผ่าน
            </label>
            <input
              className="w-full px-3 py-2 border rounded"
              type="password"
              placeholder="รหัสผ่าน" //l33iisu0
              {...register("password")}
            />
            {errors?.password && (
              <p className="text-red-500 text-xs mt-1">
                {errors.password?.message}
              </p>
            )}
          </div>

          <div className="mt-8">
            <button
              className="w-full px-3 py-2 text-white rounded-md hover:opacity-90"
              type="submit"
              style={{ backgroundColor: "#185519" }}
            >
              <span className="text-sm">เข้าสู่ระบบ</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
